export default __webpack_public_path__ + "static/media/branding-logo.8e4ac84a.svg";